import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { PaymentsTodoSelectionPanelProps } from "models/propTypes/todoSelectionPanelPropTypes";
import { CurrencyEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region component
import StoppedPaymentsSelectionFormContainer from "./forms/todoSelectionFormContainer";
import { FooterWithDivider, TitleWithDescription, TitledContainerInner } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const StoppedPaymentsTodoSelection: ForwardRefRenderFunction<FormHandles, PaymentsTodoSelectionPanelProps> = (
  props,
  ref
) => {
  return (
    <TitledContainerInner
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.StoppedSelectionPanelHeader)}
      subHeader={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Payments.StoppedSelectionPanelDescription
      )}
    >
      <StoppedPaymentsSelectionFormContainer ref={ref}></StoppedPaymentsSelectionFormContainer>
      <FooterWithDivider>
        <TitleWithDescription
          title={`${LocalizationHelperInstance.getFormattedCurrency(props.selectedPaymentsTotal)} ${
            CurrencyEnums.CurrencyCode.SEK
          }`}
          subTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.MarkedPayments, "", {
            selectedPayments: props.selectedPaymentsCount.toString(),
          })}
          helpText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.PaymentsTooltipMessage)}
        />
      </FooterWithDivider>
    </TitledContainerInner>
  );
};

export default forwardRef(StoppedPaymentsTodoSelection);
